import React from "react";
import SecNav from "./SecNav";
import Navigation from "./Navigation";

const Termscondition = () => {
  return (
    <div className="container my-5">
      <Navigation />
      <SecNav
        title={"Terms & Services"}
        body={
          "Welcome to BestEmbroidery! By accessing or using our website, you agree to comply with and be bound by the following Terms & Services. Please read these terms carefully before using our platform. If you do not agree with any part of these terms, you must not use our services."
        }
      />
      <div className="row fs-18 mt-2 mx-auto ">
        <div className="col-12">
          <div>
            <p className="mt-4">
              By using BestEmbroidery, you confirm that you are at least 18
              years old or have the consent of a legal guardian to use this
              website. Your continued use of the site constitutes your
              acceptance of these terms and any future updates. All content on
              BestEmbroidery, including designs, logos, text, and images, is the
              property of BestEmbroidery or its licensors and is protected by
              copyright and intellectual property laws. You may not reproduce,
              distribute, or use any content without prior written permission.
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question.
            </p>

            <p className="mt-4">
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question. nsors and is protected by copyright and intellectual
              property laws. You may not reproduce, distribute, or use any
              content without prior written permission. BestEmbroidery is not
              liable for any indirect, incidental, or consequential damages
              arising from the use of our website or products. Our total
              liability for any claim related to our services shall not exceed
              the amount paid for the product in question.
            </p>

            <p className="mt-4">
              By using BestEmbroidery, you confirm that you are at least 18
              years old or have the consent of a legal guardian to use this
              website. Your continued use of the site constitutes your
              acceptance of these terms and any future updates. All content on
              BestEmbroidery, including designs, logos, text, and images, is the
              property of BestEmbroidery or its licensors and is protected by
              copyright and intellectual property laws. You may not reproduce,
              distribute, or use any content without prior written permission.
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question.
            </p>

            <p className="mt-4">
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question. nsors and is protected by copyright and intellectual
              property laws. You may not reproduce, distribute, or use any
              content without prior written permission. BestEmbroidery is not
              liable for any indirect, incidental, or consequential damages
              arising from the use of our website or products. Our total
              liability for any claim related to our services shall not exceed
              the amount paid for the product in question.
            </p>

            <p className="mt-4">
              By using BestEmbroidery, you confirm that you are at least 18
              years old or have the consent of a legal guardian to use this
              website. Your continued use of the site constitutes your
              acceptance of these terms and any future updates. All content on
              BestEmbroidery, including designs, logos, text, and images, is the
              property of BestEmbroidery or its licensors and is protected by
              copyright and intellectual property laws. You may not reproduce,
              distribute, or use any content without prior written permission.
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question.
            </p>

            <p className="mt-4">
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question. nsors and is protected by copyright and intellectual
              property laws. You may not reproduce, distribute, or use any
              content without prior written permission. BestEmbroidery is not
              liable for any indirect, incidental, or consequential damages
              arising from the use of our website or products. Our total
              liability for any claim related to our services shall not exceed
              the amount paid for the product in question.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termscondition;
